(function () {
  "use strict";

  console.log("Verify Fitment JS loaded - COMPLETE FIXED VERSION");

  /* ===========================
       SEO PATCH: on-demand fitment data loader
       The site-wide DB is fetched once from the 'fitment-data' section and
       cached by the browser, instead of being inlined per page (~797KB).
    =========================== */
  let _fdPromise = null;
  function loadFitmentDataShared() {
    if (_fdPromise) return _fdPromise;
    _fdPromise = fetch("/?section_id=fitment-data", { credentials: "same-origin" })
      .then(function (r) {
        if (!r.ok) throw new Error("fitment-data fetch failed: " + r.status);
        return r.text();
      })
      .then(function (html) {
        var node = new DOMParser()
          .parseFromString(html, "text/html")
          .getElementById("vf-fitment-data");
        if (!node) throw new Error("vf-fitment-data not found");
        return JSON.parse(node.textContent);
      })
      .catch(function (err) {
        _fdPromise = null;
        throw err;
      });
    return _fdPromise;
  }

  /* ===========================
       CUSTOM SELECT CLASS - SAME AS FITMENT WIDGET
    =========================== */
  class CustomSelect {
    constructor(container, options = {}) {
      this.container = typeof container === 'string' 
        ? document.querySelector(container) 
        : container;
      
      if (!this.container) {
        console.error('CustomSelect: Container element not found');
        return;
      }

      this.options = {
        onChange: null,
        allowClear: false,
        searchable: true,
        ...options
      };

      this.init();
    }

    init() {
      this.wrapper = this.container;
      this.containerEl = this.wrapper.querySelector('.custom-select-container');
      this.trigger = this.wrapper.querySelector('.custom-select-trigger');
      this.dropdown = this.wrapper.querySelector('.custom-select-dropdown');
      this.nativeSelect = this.wrapper.querySelector('.custom-select-native');
      this.triggerText = this.wrapper.querySelector('.custom-select-trigger-text');
      this.searchInput = this.wrapper.querySelector('.custom-select-search-input');
      this.optionsContainer = this.wrapper.querySelector('.custom-select-options');
      this.optionsList = this.wrapper.querySelectorAll('.custom-select-option');
      
      if (this.trigger) {
        this.placeholder = this.triggerText?.textContent || 'Select option';
        this.trigger.dataset.placeholder = this.placeholder;
      }
      
      this.isOpen = false;
      this.selectedValue = '';
      this.selectedLabel = '';

      this.toggleDropdown = this.toggleDropdown.bind(this);
      this.closeDropdown = this.closeDropdown.bind(this);
      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleOptionClick = this.handleOptionClick.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.handleClickOutside = this.handleClickOutside.bind(this);
      this.handleSearch = this.handleSearch.bind(this);

      this.attachEvents();
      this.setupAccessibility();
    }

    attachEvents() {
      this.trigger.addEventListener('click', this.handleTriggerClick);
      this.addOptionListeners();

      if (this.searchInput) {
        this.searchInput.addEventListener('input', this.handleSearch);
        this.searchInput.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.closeDropdown();
          }
          e.stopPropagation();
        });
      }

      document.addEventListener('click', this.handleClickOutside);
      document.addEventListener('keydown', this.handleKeyDown);
    }

    addOptionListeners() {
      this.optionsList.forEach(option => {
        option.removeEventListener('click', this.handleOptionClick);
        option.addEventListener('click', this.handleOptionClick);
      });
    }

    setupAccessibility() {
      this.trigger.setAttribute('aria-expanded', 'false');
      this.trigger.setAttribute('aria-label', 'Select an option');
      this.trigger.setAttribute('aria-haspopup', 'listbox');
      
      if (this.dropdown) {
        this.dropdown.setAttribute('role', 'listbox');
      }

      this.optionsList.forEach((option, index) => {
        option.setAttribute('role', 'option');
        option.setAttribute('tabindex', '-1');
        option.setAttribute('aria-selected', 'false');
        if (index === 0) {
          option.setAttribute('id', `${this.wrapper.dataset.selectId || 'custom-select'}-option-${index}`);
        }
      });
    }

    handleTriggerClick(e) {
      e.preventDefault();
      e.stopPropagation();
      this.toggleDropdown();
    }

    handleOptionClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const option = e.currentTarget;
      const value = option.dataset.value;
      const label = option.textContent.trim();

      if (option.classList.contains('disabled')) {
        return;
      }

      console.log('Option clicked:', value, label);
      
      this.setValue(value, label);
      this.closeDropdown();

      if (typeof this.options.onChange === 'function') {
        this.options.onChange({ value, label, originalEvent: e });
      }
    }

    handleKeyDown(e) {
      if (e.key === 'Escape' && this.isOpen) {
        this.closeDropdown();
        e.preventDefault();
      }

      if (this.isOpen && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
        e.preventDefault();
        this.navigateOptions(e.key);
      }

      if (this.isOpen && e.key === 'Enter') {
        e.preventDefault();
        const focusedOption = this.dropdown.querySelector('.custom-select-option.focused');
        if (focusedOption && !focusedOption.classList.contains('disabled')) {
          this.handleOptionClick({ currentTarget: focusedOption });
        }
      }
    }

    handleClickOutside(e) {
      if (!this.containerEl.contains(e.target) && this.isOpen) {
        this.closeDropdown();
      }
    }

    handleSearch(e) {
      const searchTerm = e.target.value.toLowerCase();
      
      this.optionsList.forEach(option => {
        const text = option.textContent.toLowerCase();
        const shouldShow = text.includes(searchTerm);
        option.style.display = shouldShow ? 'block' : 'none';
      });

      const hasVisibleOptions = Array.from(this.optionsList).some(
        opt => opt.style.display !== 'none' && !opt.classList.contains('disabled')
      );

      let noResultsEl = this.dropdown.querySelector('.custom-select-no-results');
      
      if (!hasVisibleOptions) {
        if (!noResultsEl) {
          noResultsEl = document.createElement('div');
          noResultsEl.className = 'custom-select-option disabled custom-select-no-results';
          noResultsEl.textContent = 'No results found';
          noResultsEl.setAttribute('role', 'option');
          this.optionsContainer.appendChild(noResultsEl);
        }
      } else if (noResultsEl) {
        noResultsEl.remove();
      }
    }

    navigateOptions(direction) {
      const visibleOptions = Array.from(this.optionsList)
        .filter(opt => opt.style.display !== 'none' && !opt.classList.contains('disabled'));
      
      if (visibleOptions.length === 0) return;

      visibleOptions.forEach(opt => opt.classList.remove('focused'));

      const currentIndex = visibleOptions.findIndex(opt => opt.classList.contains('focused'));
      
      let nextIndex;
      if (direction === 'ArrowDown') {
        nextIndex = currentIndex < visibleOptions.length - 1 ? currentIndex + 1 : 0;
      } else {
        nextIndex = currentIndex > 0 ? currentIndex - 1 : visibleOptions.length - 1;
      }

      visibleOptions[nextIndex].classList.add('focused');
      visibleOptions[nextIndex].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    toggleDropdown() {
      this.isOpen ? this.closeDropdown() : this.openDropdown();
    }

    openDropdown() {
      this.isOpen = true;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.containerEl.classList.add('is-open');
      
      const rect = this.trigger.getBoundingClientRect();
      this.dropdown.style.top = rect.height + 'px';
      
      if (this.searchInput) {
        setTimeout(() => this.searchInput.focus(), 100);
      }

      if (this.searchInput) {
        this.searchInput.value = '';
        this.optionsList.forEach(opt => opt.style.display = 'block');
      }

      const noResultsEl = this.dropdown.querySelector('.custom-select-no-results');
      if (noResultsEl) noResultsEl.remove();
    }

    closeDropdown() {
      this.isOpen = false;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.containerEl.classList.remove('is-open');
      
      if (this.searchInput) {
        this.searchInput.value = '';
        this.optionsList.forEach(opt => opt.style.display = 'block');
      }
    }

    setValue(value, label) {
      this.selectedValue = value;
      this.selectedLabel = label || value;

      if (this.triggerText) {
        this.triggerText.textContent = this.selectedLabel || this.placeholder;
      }

      if (this.nativeSelect) {
        this.nativeSelect.value = value || '';
        this.nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      this.optionsList.forEach(option => {
        if (option.dataset.value === value) {
          option.classList.add('selected');
          option.setAttribute('aria-selected', 'true');
        } else {
          option.classList.remove('selected');
          option.setAttribute('aria-selected', 'false');
        }
      });
    }

    getValue() {
      return {
        value: this.selectedValue,
        label: this.selectedLabel
      };
    }

    reset() {
      this.setValue('', this.placeholder);
    }

    disable(disabled = true) {
      if (disabled) {
        this.containerEl.classList.add('is-disabled');
        this.trigger.setAttribute('disabled', 'disabled');
        this.trigger.setAttribute('aria-disabled', 'true');
        this.trigger.style.pointerEvents = 'none';
        this.trigger.style.opacity = '0.6';
      } else {
        this.containerEl.classList.remove('is-disabled');
        this.trigger.removeAttribute('disabled');
        this.trigger.setAttribute('aria-disabled', 'false');
        this.trigger.style.pointerEvents = '';
        this.trigger.style.opacity = '';
      }
    }

    setLoading(loading = true) {
      if (loading) {
        this.containerEl.classList.add('is-loading');
        this.trigger.setAttribute('aria-busy', 'true');
      } else {
        this.containerEl.classList.remove('is-loading');
        this.trigger.setAttribute('aria-busy', 'false');
      }
    }

    setOptions(options) {
      if (!this.optionsContainer) return;

      this.optionsContainer.innerHTML = '';

      options.forEach(opt => {
        const optionEl = document.createElement('div');
        optionEl.className = 'custom-select-option';
        optionEl.dataset.value = opt.value;
        optionEl.textContent = opt.label;
        optionEl.setAttribute('role', 'option');
        this.optionsContainer.appendChild(optionEl);
      });

      this.optionsList = this.wrapper.querySelectorAll('.custom-select-option');
      
      this.optionsList.forEach((option, index) => {
        option.setAttribute('role', 'option');
        option.setAttribute('tabindex', '-1');
        option.setAttribute('aria-selected', 'false');
      });

      this.addOptionListeners();
    }

    destroy() {
      this.trigger.removeEventListener('click', this.handleTriggerClick);
      document.removeEventListener('click', this.handleClickOutside);
      document.removeEventListener('keydown', this.handleKeyDown);
      
      if (this.searchInput) {
        this.searchInput.removeEventListener('input', this.handleSearch);
      }

      this.optionsList.forEach(option => {
        option.removeEventListener('click', this.handleOptionClick);
      });

      this.container = null;
      this.wrapper = null;
      this.containerEl = null;
      this.trigger = null;
      this.dropdown = null;
      this.nativeSelect = null;
      this.triggerText = null;
      this.searchInput = null;
      this.optionsList = null;
    }
  }


  
  async function initVerifyFitment(config) {
    console.log("Verify Fitment initializing with config:", config);

    if (!config) {
      console.error("No configuration provided to initVerifyFitment");
      return;
    }

    /* SEO PATCH: fetch the shared DB on demand if not inlined */
    if (!config.fitmentData) {
      var _sk = document.getElementById("vf-skeleton-container");
      if (_sk) { _sk.style.display = "block"; _sk.classList.remove("hidden"); }
      try {
        config.fitmentData = await loadFitmentDataShared();
      } catch (err) {
        console.error("Verify Fitment: could not load fitment data.", err);
        return;
      }
    }

    const fitmentData = config.fitmentData;
    const productFitments = config.productFitments || [];
    const productId = config.productId;

    if (!fitmentData || !fitmentData.options_lookup) {
      console.error("Missing fitment data or options_lookup");
      return;
    }

    console.log("Product has fitments - showing skeleton while loading");

    const skeleton = document.getElementById("vf-skeleton-container");
    const wrapper = document.getElementById("verify-fitment-wrapper");
    const widgetContainer = document.querySelector(
      ".verify-fitment-vertical-wrapper",
    );

    if (skeleton) {
      skeleton.style.display = "block";
      skeleton.classList.remove("hidden");
    }

    if (wrapper) {
      wrapper.classList.remove("hidden");
      wrapper.style.display = "none";
    }

    if (widgetContainer) {
      widgetContainer.classList.remove("hidden");
      widgetContainer.style.display = "none";
    }

    const lookups = {
      makes: fitmentData.options_lookup.make || [],
      models: fitmentData.options_lookup.model || [],
      engines: fitmentData.options_lookup.engine || [],
      years: fitmentData.options_lookup.year || [],
    };

    const compressedRows = fitmentData.compressed_rows || [];

    // ── Bail out when the widget is not on this page ──────────────────────
    //
    // partra-verify-fitment.liquid renders the whole widget only inside
    //   {% if vf.settings.active and is_universal == false %}
    // so on a UNIVERSAL product (isuniversal true, or unset) none of the
    // markup below exists and every lookup in `elements` resolves to null.
    //
    // The script carried on regardless, and the first unguarded `.classList`
    // threw - which killed the handler and left the PDP with no image, title or
    // price. It only reproduced once a vehicle was saved, because that is what
    // triggers showResultView()/showSelectionView().
    //
    // Guarding every individual access would be a long list that the next
    // addition to this file would quietly miss. One check for the widget root is
    // the honest version: if the widget was not rendered, there is nothing here
    // to initialise.
    if (!document.getElementById("verify-fitment")) {
      console.log("[verify-fitment] widget not present on this page - skipping init");
      return;
    }

    const elements = {
      modeButtons: document.querySelectorAll(".vf-vertical-btn"),
      contentAreas: document.querySelectorAll(
        ".vf-vertical-content, .vf-vertical-content-registration",
      ),
      titles: document.querySelectorAll(".vf-vertical-title"),
      browseErrorTooltip: document.getElementById("vf-browse-error-tooltip"),

      makeSelect: document.getElementById("vf-make-select"),
      modelSelect: document.getElementById("vf-model-select"),
      engineSelect: document.getElementById("vf-engine-select"),
      yearSelect: document.getElementById("vf-year-select"),

      checkBtn: document.getElementById("vf-check"),

      plate: document.getElementById("vf-plate"),
      checkPlateBtn: document.getElementById("vf-check-plate"),
      clearPlateBtn: document.getElementById("vf-clear-plate"),

      resultContainer: document.getElementById("vf-result-container"),
      resultIcon: document.querySelector(".vf-result-icon"),
      successIcon: document.querySelector(".vf-success-icon"),
      errorIcon: document.querySelector(".vf-error-icon"),
      resultText: document.querySelector(".vf-result-text"),
      vehicleDetails: document.querySelector(".vf-vehicle-details"),
      changeVehicleBtn: document.getElementById("vf-change-vehicle"),
      browseBtn: document.getElementById("vf-browse-products"),
      resultPlateWrapper: document.getElementById("vf-result-plate-wrapper"),

      resultPlate: document.getElementById("vf-result-plate"),
      actionsRow: document.getElementById("vf-actions-row"),
      errorMessage: document.getElementById("vf-error-message"),
      errorMessageModel: document.getElementById("vf-error-message-model"),
      errorText: document.getElementById("vf-error-text"),
      errorTextModel: document.getElementById("vf-error-text-model"),
    };
    window.addEventListener('scroll', () => {
      document.querySelector('.vf-info-icon')?.classList.remove('active');
    }, { passive: true });

    let currentMode =
      document.querySelector(".vf-vertical-btn.active")?.dataset.vfMode ||
      "registration";
    let currentVehicle = null;
    let savedVehicle = null;

    function loadSavedVehicle() {
      try {
        const savedVehicleData = localStorage.getItem("vehicle_fitment_active");
        if (savedVehicleData) {
          savedVehicle = JSON.parse(savedVehicleData);
          console.log("Loaded saved vehicle from localStorage:", savedVehicle);
          return savedVehicle;
        }
      } catch (error) {
        console.error("Error loading saved vehicle from localStorage:", error);
      }
      return null;
    }

    function autoCheckSavedVehicle() {
      const saved = loadSavedVehicle();
      if (!saved) return;

      console.log("Auto-checking saved vehicle:", saved);

       if (elements.resultPlateWrapper) {
        if (saved.type === 'registration' && saved.registrationNumber) {
          elements.resultPlateWrapper.classList.remove("hidden");
          if (elements.resultPlate) {
            elements.resultPlate.value = saved.registrationNumber;
          }
        } else {
          elements.resultPlateWrapper.classList.add("hidden");
        }
      }

      if (saved.make && saved.model && saved.year) {
        const vehicle = {
          make: saved.make,
          model: saved.model,
          engine: saved.engine || "",
          year: parseInt(saved.year) || 0,
        };

        const isCompatible = checkVehicleCompatibility(vehicle,saved.type === 'registration');

        const details = `${vehicle.make} ${vehicle.model}${vehicle.engine ? " " + vehicle.engine : ""} (${vehicle.year})`;

        if (isCompatible) {
          messaging.showResult(
            "compatible",
            "This product is compatible with your vehicle",
            details,
          );
        } else {
          messaging.showResult(
            "not-compatible",
            "This product is not compatible with your vehicle",
            details,
          );
        }
      }
    }

    function normalize(str) {
      return String(str || "")
        .replace(/,/g, "-")
        .replace(/\//g, "-")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-+|-+$/g, "");
    }

    function matchesField(productValue, selectedValue) {
      if (!productValue || !selectedValue) return false;
      return normalize(productValue).startsWith(normalize(selectedValue));
    }

    function parseYearRange(range) {
      if (!range) return null;

      const exclusiveMatch = String(range).match(/\[(\d{4}),(\d{4})\)/);
      if (exclusiveMatch) {
        const start = Number(exclusiveMatch[1]);
        const rawEnd = Number(exclusiveMatch[2]);
        return { start: start, end: rawEnd, exclusiveUpper: false };
      }

      const inclusiveMatch = String(range).match(/\[(\d{4}),(\d{4})\]/);
      if (inclusiveMatch) {
        const start = Number(inclusiveMatch[1]);
        const end = Number(inclusiveMatch[2]);
        return { start: start, end: end, exclusiveUpper: false };
      }

      const dashMatch = String(range).match(/(\d{4})\s*-\s*(\d{4})/);
      if (dashMatch) {
        const start = parseInt(dashMatch[1], 10);
        const end = parseInt(dashMatch[2], 10);
        return { start: start, end: end, exclusiveUpper: false };
      }

      const singleMatch = String(range).match(/^(\d{4})$/);
      if (singleMatch) {
        const year = parseInt(singleMatch[1], 10);
        return { start: year, end: year, exclusiveUpper: false };
      }

      return null;
    }

    const messaging = {
      showError(message) {
        elements.errorText.textContent = message;
        elements.errorMessage.classList.remove("hidden");
        elements.errorMessage.classList.add("visible");
        var vfCard = document.querySelector('.verify-fitment-vertical');
        if (vfCard) vfCard.classList.add('vf-highlight-error');
        setTimeout(() => { this.hideError(); }, 3000);
      },
     showErrorModel(message) { 
        elements.errorTextModel.textContent = message;
        elements.errorMessageModel.classList.remove("hidden");
        elements.errorMessageModel.classList.add("visible");
        setTimeout(() => { this.hideErrorModel(); }, 3000);
      },

      showBrowseError(message) {
        if (!elements.browseErrorTooltip) return;
        elements.browseErrorTooltip.textContent = message;
        elements.browseErrorTooltip.classList.remove("hidden");
        setTimeout(() => { elements.browseErrorTooltip.classList.add("hidden"); }, 3000);
      },

      hideError() {
        elements.errorMessage.classList.add("hidden");
        elements.errorMessage.classList.remove("visible");
        var vfCard = document.querySelector('.verify-fitment-vertical');
        if (vfCard) vfCard.classList.remove('vf-highlight-error');
      },
        hideErrorModel() {
        elements.errorMessageModel.classList.add("hidden");
        elements.errorMessageModel.classList.remove("visible");
      },

      showResult(type, message, details = "") {
        if (elements.actionsRow && elements.browseBtn) {
          const browseVisible = !elements.browseBtn.classList.contains("hidden");
          if (browseVisible) {
            elements.actionsRow.classList.remove("vf-single-action");
          } else {
            elements.actionsRow.classList.add("vf-single-action");
          }
        }

        if (elements.successIcon) { elements.successIcon.classList.add("hidden"); }
        if (elements.errorIcon) { elements.errorIcon.classList.add("hidden"); }

        elements.resultIcon.textContent = "";
        elements.resultIcon.classList.remove("vf-loading", "vf-error");

        switch (type) {
          case "compatible":
            if (elements.successIcon) {
              elements.successIcon.classList.remove("hidden");
              const svg = elements.successIcon.querySelector("svg");
              if (svg) { svg.style.display = "block"; }
            }
            break;
          case "not-compatible":
            if (elements.errorIcon) {
              elements.errorIcon.classList.remove("hidden");
              const svg = elements.errorIcon.querySelector("svg");
              if (svg) { svg.style.display = "block"; }
            }
            break;
          case "loading":
            elements.resultIcon.classList.add("vf-loading");
            const loadingSpan = document.createElement("span");
            loadingSpan.className = "vf-loading-indicator";
            loadingSpan.textContent = "\u27f3";
            loadingSpan.style.cssText = `font-size: 24px; animation: spin 1s linear infinite; display: block; margin: 0 auto;`;
            elements.resultIcon.appendChild(loadingSpan);
            break;
          case "error":
            elements.resultIcon.classList.add("vf-error");
            const errorSpan = document.createElement("span");
            errorSpan.className = "vf-error-indicator";
            errorSpan.textContent = "!";
            errorSpan.style.cssText = `font-size: 24px; color: #C53030; display: block; margin: 0 auto;`;
            elements.resultIcon.appendChild(errorSpan);
            break;
        }

        elements.resultContainer.className = "vf-result-container";
        elements.resultContainer.classList.add(type);
        elements.resultContainer.classList.add("visible");
        elements.resultContainer.classList.remove("hidden");

        elements.resultText.textContent = message;

        if (elements.browseBtn && elements.changeVehicleBtn) {
          if (type === "compatible") {
            elements.browseBtn.classList.add("hidden");
          } else if (type === "not-compatible") {
            elements.browseBtn.classList.remove("hidden");
          } else {
            elements.browseBtn.classList.add("hidden");
          }
        }

        if (typeof details === "string") {
          if (details === "") {
            elements.vehicleDetails.style.display = "none";
            elements.vehicleDetails.textContent = "";
          } else {
            elements.vehicleDetails.style.display = "block";
            elements.vehicleDetails.textContent = details;
          }
        } else {
          elements.vehicleDetails.style.display = "block";
          elements.vehicleDetails.innerHTML = details;
        }

        elements.contentAreas.forEach((area) => {
          area.classList.remove("active");
          area.classList.add("hidden");
        });

        // The toggle and header only exist inside the
        // `{% if vf.settings.active and is_universal == false %}` block in
        // partra-verify-fitment.liquid. On a UNIVERSAL product (isuniversal true
        // or unset) that markup is never rendered, so these are null and
        // .classList threw - killing the handler mid-run and leaving the product
        // section blank. It only showed up once a vehicle was saved, because that
        // is the only thing that calls this.
        const vfToggle = document.querySelector(".vf-vertical-toggle");
        const vfHeader = document.querySelector(".vf-vertical-header");
        if (vfToggle) vfToggle.classList.add("hidden");
        if (vfHeader) vfHeader.classList.add("hidden");
      },

      showSelectionView() {
        elements.resultContainer.classList.add("hidden");
        elements.plate.value= "";
        elements.resultContainer.classList.remove("visible");
        localStorage.removeItem("vehicle_fitment_active");
        localStorage.removeItem('vehicle_fitment_all_handles');
        elements.resultIcon.textContent = "";
        elements.resultIcon.classList.remove("vf-loading", "vf-error");

        const indicators = elements.resultIcon.querySelectorAll(
          ".vf-loading-indicator, .vf-error-indicator",
        );
        indicators.forEach((indicator) => indicator.remove());

        if (elements.successIcon) { elements.successIcon.classList.add("hidden"); }
        if (elements.errorIcon) { elements.errorIcon.classList.add("hidden"); }

        const currentContent = document.querySelector(
          `[data-vf-content="${currentMode}"]`,
        );
        if (currentContent) {
          currentContent.classList.add("active");
          currentContent.classList.remove("hidden");
        }

        // Same guard as showResultView - absent on universal products.
        const vfToggleSel = document.querySelector(".vf-vertical-toggle");
        const vfHeaderSel = document.querySelector(".vf-vertical-header");
        if (vfToggleSel) vfToggleSel.classList.remove("hidden");
        if (vfHeaderSel) vfHeaderSel.classList.remove("hidden");

        this.hideError();
      },
    };

    const customSelects = {};

    function initializeCustomSelects() {
      console.log("Initializing custom selects for verify fitment...");

      const getWrapper = (element) => {
        if (!element) return null;
        return element.querySelector('.custom-select-wrapper');
      };

      if (elements.makeSelect) {
        const wrapper = getWrapper(elements.makeSelect);
        if (wrapper) {
          console.log('Initializing make select');
          const makeNativeSelect = wrapper.querySelector('.custom-select-native');
          if (makeNativeSelect) {
            makeNativeSelect.innerHTML = '<option value="">Make</option>';
            lookups.makes.forEach((make, index) => {
              const option = document.createElement('option');
              option.value = index;
              option.textContent = make;
              makeNativeSelect.appendChild(option);
            });
          }
          customSelects.make = new CustomSelect(wrapper, {
            onChange: ({ value }) => handleMakeChange(value)
          });
        }
      }

      if (elements.modelSelect) {
        const wrapper = getWrapper(elements.modelSelect);
        if (wrapper) {
          console.log('Initializing model select');
          const modelNativeSelect = wrapper.querySelector('.custom-select-native');
          if (modelNativeSelect) { modelNativeSelect.innerHTML = '<option value="">Model</option>'; }
          customSelects.model = new CustomSelect(wrapper, {
            onChange: ({ value }) => handleModelChange(value)
          });
          if (customSelects.model) customSelects.model.disable(true);
        }
      }

      if (elements.engineSelect) {
        const wrapper = getWrapper(elements.engineSelect);
        if (wrapper) {
          console.log('Initializing engine select');
          const engineNativeSelect = wrapper.querySelector('.custom-select-native');
          if (engineNativeSelect) { engineNativeSelect.innerHTML = '<option value="">Engine</option>'; }
          customSelects.engine = new CustomSelect(wrapper, {
            onChange: ({ value }) => handleEngineChange(value)
          });
          if (customSelects.engine) customSelects.engine.disable(true);
        }
      }

      if (elements.yearSelect) {
        const wrapper = getWrapper(elements.yearSelect);
        if (wrapper) {
          console.log('Initializing year select');
          const yearNativeSelect = wrapper.querySelector('.custom-select-native');
          if (yearNativeSelect) { yearNativeSelect.innerHTML = '<option value="">Year</option>'; }
          customSelects.year = new CustomSelect(wrapper, {
            onChange: ({ value }) => handleYearChange(value)
          });
          if (customSelects.year) customSelects.year.disable(true);
        }
      }

      console.log("Custom selects initialized:", Object.keys(customSelects));
    }

    function handleMakeChange(makeIndex) {
      console.log("Make changed to value:", makeIndex);
      if (customSelects.model) { customSelects.model.reset(); customSelects.model.disable(true); }
      if (customSelects.engine) { customSelects.engine.reset(); customSelects.engine.disable(true); }
      if (customSelects.year) { customSelects.year.reset(); customSelects.year.disable(true); }

      if (!makeIndex) return;

      const modelIndices = new Set();
      compressedRows.forEach((row) => {
        const [m, mo] = row.split(" ").map(Number);
        if (m == makeIndex) modelIndices.add(mo);
      });

      if (customSelects.model) {
        const modelOptions = Array.from(modelIndices).map((i) => ({
          value: i.toString(),
          label: lookups.models[i] || `Model ${i}`,
        }));
        customSelects.model.setOptions(modelOptions);
        customSelects.model.disable(false);
      }
    }

    function handleModelChange(modelIndex) {
      console.log("Model changed to value:", modelIndex);
      if (customSelects.engine) { customSelects.engine.reset(); customSelects.engine.disable(true); }
      if (customSelects.year) { customSelects.year.reset(); customSelects.year.disable(true); }

      if (!modelIndex) return;

      const makeValue = customSelects.make?.getValue().value;
      if (!makeValue) return;

      const engineIndices = new Set();
      compressedRows.forEach((row) => {
        const [m, mo, e] = row.split(" ").map(Number);
        if (m == makeValue && mo == modelIndex) { engineIndices.add(e); }
      });

      if (customSelects.engine) {
        const engineOptions = Array.from(engineIndices).map((i) => ({
          value: i.toString(),
          label: lookups.engines[i] || `Engine ${i}`,
        }));
        customSelects.engine.setOptions(engineOptions);
        customSelects.engine.disable(false);
      }
    }

    function handleEngineChange(engineIndex) {
      console.log("Engine changed to value:", engineIndex);
      if (customSelects.year) { customSelects.year.reset(); customSelects.year.disable(true); }

      if (!engineIndex) return;

      const makeValue = customSelects.make?.getValue().value;
      const modelValue = customSelects.model?.getValue().value;
      if (!makeValue || !modelValue) return;

      const yearsSet = new Set();
      compressedRows.forEach((row) => {
        const [m, mo, e, y] = row.split(" ").map(Number);
        if (m == makeValue && mo == modelValue && e == engineIndex) {
          const [start, end] = lookups.years[y].split("-").map(Number);
          for (let year = start; year <= end; year++) { yearsSet.add(year); }
        }
      });

      if (customSelects.year) {
        const yearOptions = Array.from(yearsSet)
          .sort((a, b) => b - a)
          .map((year) => ({ value: year.toString(), label: year.toString() }));
        customSelects.year.setOptions(yearOptions);
        customSelects.year.disable(false);
      }
    }

    function handleYearChange(year) {
      console.log("Year changed to value:", year);
    }

    function getSelectedVehicle() {
      const makeValue = customSelects.make?.getValue().value;
      const modelValue = customSelects.model?.getValue().value;
      const engineValue = customSelects.engine?.getValue().value;
      const yearValue = customSelects.year?.getValue().value;

      const makeIndex = makeValue ? parseInt(makeValue) : null;
      const modelIndex = modelValue ? parseInt(modelValue) : null;
      const engineIndex = engineValue ? parseInt(engineValue) : null;
      const year = yearValue ? parseInt(yearValue) : null;

      if (makeIndex === null || modelIndex === null || year === null) { return null; }

      return {
        makeIndex, modelIndex, engineIndex, year,
        make: lookups.makes[makeIndex],
        model: lookups.models[modelIndex],
        engine: engineIndex !== null ? lookups.engines[engineIndex] : null,
      };
    }

    const modeManager = {
      init() {
        if (!elements.modeButtons.length) {
          console.error("Mode buttons not found");
          return;
        }
        elements.modeButtons.forEach((btn) => {
          btn.addEventListener("click", (e) => {
            const mode = e.currentTarget.dataset.vfMode;
            this.switchMode(mode);
          });
        });
      },

      switchMode(mode) {
        currentMode = mode;
        const elem=document.querySelector('.vf-vertical-content-wrapper')
        if(mode==="registration"){
          if(elem) elem.classList.add("hidden")
        }else{
          elem.classList.remove("hidden")
        }
        elements.modeButtons.forEach((btn) => {
          if (btn.dataset.vfMode === mode) { btn.classList.add("active"); }
          else { btn.classList.remove("active"); }
        });

        elements.contentAreas.forEach((area) => {
          if (area.dataset.vfContent === mode) {
            area.classList.add("active");
            area.classList.remove("hidden");
            if (mode === "registration") {
              const regTitle = area.querySelector(".vf-vertical-registration-title");
              if (regTitle) { regTitle.classList.remove("hidden"); }
              const regInput = area.querySelector(".vf-vertical-input-container");
              if (regInput) { regInput.classList.remove("hidden"); }
            }
          } else {
            area.classList.remove("active");
            area.classList.add("hidden");
            if (area.dataset.vfContent === "registration") {
              const regTitle = area.querySelector(".vf-vertical-registration-title");
              if (regTitle) { regTitle.classList.add("hidden"); }
              const regInput = area.querySelector(".vf-vertical-input-container");
              if (regInput) { regInput.classList.add("hidden"); }
            }
          }
        });

        elements.titles.forEach((title) => {
          if (title.dataset.vfTitle === mode) { title.classList.add("active"); }
          else { title.classList.remove("active"); }
        });

        messaging.hideError();

        setTimeout(() => {
          if (mode === "model") {
            if (customSelects.make) { customSelects.make.trigger.focus(); }
          } else if (mode === "registration") {
            if (elements.plate) elements.plate.focus();
          }
        }, 100);
      },
    };

    async function verifyByModel() {
      const vehicle = getSelectedVehicle();
      if (!vehicle) { messaging.showErrorModel("Please select Make, Model, and Year"); return; }
      currentVehicle = vehicle;
      if (elements.resultPlateWrapper) { elements.resultPlateWrapper.classList.add("hidden"); }

      messaging.showResult("loading", "Checking compatibility...",
        `${vehicle.make} ${vehicle.model}${vehicle.engine ? " " + vehicle.engine : ""} (${vehicle.year})`);

      try {
        const isCompatible = checkVehicleCompatibility(vehicle);
        if (isCompatible) {
          messaging.showResult("compatible", "This product is compatible with your vehicle",
            `${vehicle.make} ${vehicle.model}${vehicle.engine ? " " + vehicle.engine : ""} (${vehicle.year})`);
        } else {
          messaging.showResult("not-compatible", "This product is not compatible with your vehicle",
            `${vehicle.make} ${vehicle.model}${vehicle.engine ? " " + vehicle.engine : ""} (${vehicle.year})`);
        }

        const vehicleActive = {
          type: 'model', make: vehicle.make, model: vehicle.model,
          engine: vehicle.engine || '', year: vehicle.year,
          rawCarName: `${vehicle.make} ${vehicle.model}${vehicle.engine ? ' ' + vehicle.engine : ''}`,
          slug: `${vehicle.make}-${vehicle.model}`.replace(/\s+/g, '-').toLowerCase(),
          savedAt: Date.now()
        };
        localStorage.setItem('vehicle_fitment_active', JSON.stringify(vehicleActive));

        const vehiclesDon = [{
          make: encodeURIComponent(vehicle.make || ''),
          model: encodeURIComponent(vehicle.model || ''),
          engine: encodeURIComponent(vehicle.engine || ''),
          year: encodeURIComponent(vehicle.year || '')
        }];
        localStorage.setItem('vehiclesDon', JSON.stringify(vehiclesDon));
        document.dispatchEvent(new CustomEvent('partra:vehicle-saved'));

        (function() {
          var make = encodeURIComponent(vehicle.make || '');
          var model = encodeURIComponent(vehicle.model || '');
          var engine = encodeURIComponent(vehicle.engine || '');
          var year = encodeURIComponent(vehicle.year || '');
          var url = '/a/vehicles/vehicleSearchJson?make=' + make + '&model=' + model + '&engine=' + engine + '&year=' + year;
          fetch(url)
            .then(function(res) { return res.json(); })
            .then(function(data) {
              if (data && Array.isArray(data.all_product_handles) && data.all_product_handles.length > 0) {
                localStorage.setItem('vehicle_fitment_all_handles', JSON.stringify({
                  handles: data.all_product_handles, timestamp: Date.now()
                }));
                if (typeof window.filterRelatedProductsByFitment === 'function') { window.filterRelatedProductsByFitment(); }
                if (typeof window.filterRecentlyViewedByFitment === 'function') { window.filterRecentlyViewedByFitment(); }
                if (typeof window.doResolveFitmentLabels === 'function') { window.doResolveFitmentLabels(); }
              }
            })
            .catch(function(err) { console.warn('[verifyByModel] Background handle fetch failed:', err); });
        })();
      } catch (error) {
        console.error("Verification error:", error);
        messaging.showResult("error", "Unable to verify compatibility. Please try again.",
          `${vehicle.make} ${vehicle.model}${vehicle.engine ? " " + vehicle.engine : ""} (${vehicle.year})`);
      }
    }

    async function verifyByRegistration() {
      const plate = elements.plate.value.trim().toUpperCase();
      if (elements.resultPlateWrapper) { elements.resultPlateWrapper.classList.remove("hidden"); }
      if (elements.resultPlate) { elements.resultPlate.value = plate; }
      if (elements.actionsRow) { elements.actionsRow.classList.remove("hidden"); }
      if (!plate) { messaging.showError("Please enter a registration number"); return; }
      if (!/^[A-Z0-9\s-]{1,10}$/.test(plate)) {
        messaging.showError("Invalid registration format. Please enter a valid UK registration.");
        return;
      }

      const vfLoadingTooltip = document.getElementById('vf-reg-loading-tooltip');
      if (vfLoadingTooltip) vfLoadingTooltip.classList.remove('hidden');
      try {
        const data = await checkRegistrationFitment(plate, productId);
        if (data.success) {
          const vehicleDetails = data.vehicle || {};
          const make = vehicleDetails.make || "";
          const model = vehicleDetails.model || "";
          const engine = vehicleDetails.engine || "";
          const year = vehicleDetails.year || "";
          const isCompatible = data.fitment === true;
          let detailsHTML = `${make} ${model}${engine ? " " + engine : ""} (${year})`;

          if (isCompatible) {
            messaging.showResult("compatible", "This product is compatible with your vehicle", detailsHTML);
          } else {
            messaging.showResult("not-compatible", "This product is not compatible with your vehicle", detailsHTML);
          }
          const vehicleActive = {
            type: 'registration', registrationNumber: plate,
            make: make, model: model, engine: engine,
            rawCarName: `${make} ${model} ${engine}`,
            slug: `${make} ${model} ${engine}`.replace(/[^a-zA-Z0-9]+/g, '-').replace(/^-+|-+$/g, ''),
            savedAt: Date.now(), year: year
          };
          if (vfLoadingTooltip) vfLoadingTooltip.classList.add('hidden');
          localStorage.setItem('vehicle_fitment_active', JSON.stringify(vehicleActive));
          if (data.all_product_handles && data.all_product_handles.length > 0) {
            localStorage.setItem('vehicle_fitment_all_handles', JSON.stringify({
              handles: data.all_product_handles, timestamp: Date.now()
            }));
          }
          document.dispatchEvent(new CustomEvent('partra:vehicle-saved'));
          localStorage.setItem('vehiclesDon', JSON.stringify(data.vehicles || [{ make, model, engine, year }]));
        } else {
          if (vfLoadingTooltip) vfLoadingTooltip.classList.add('hidden');
          messaging.showError("Invalid number plate. Please enter a valid number.");
        }
      } catch (error) {
        console.error("Registration verification error:", error);
        if (vfLoadingTooltip) vfLoadingTooltip.classList.add('hidden');
        messaging.showError("Unable to verify registration. Please try again.");
      }
    }

    async function checkRegistrationFitment(registrationNumber, productId) {
      try {
        const response = await fetch("/a/vehicles/registrationVerification", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ registrationNumber: registrationNumber, productId: productId }),
        });
        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error checking fitment:", error);
        throw error;
      }
    }

    /**
     * Normalise a vehicle field for comparison.
     *
     * ── The bug this fixes (2026-08) ──────────────────────────────────────
     * The collection page and this widget disagreed: a registration search would
     * LIST a product as fitting, then that product's PDP said "not compatible".
     * Same vehicle, same product, opposite answers.
     *
     * Cause: the two sides compare differently.
     *   • The COLLECTION list comes from the app proxy, which matches make/model
     *     as separate DB columns and SPLITS the engine on ", " into fuelType +
     *     carTitle (see parseEngine in GET-vehicleSearchJson.ts).
     *   • This widget compared the WHOLE engine string with `===` after only
     *     trim() + toLowerCase().
     *
     * Strict equality then failed on three separate things:
     *   1. ACCENTS — "CITROËN" vs "CITROEN". Cartell, TecDoc and Shopify do not
     *      agree on diacritics, so the byte sequences differ even though a human
     *      reads them as identical. This was the reported case.
     *   2. WHITESPACE — "1.2 PureTech  82" vs "1.2 PureTech 82", and non-breaking
     *      spaces ( ) which arrive from some data sources and are NOT matched
     *      by a literal " ".
     *   3. PUNCTUATION/SEPARATORS — "Petrol, 1.2 PureTech 82" vs
     *      "Petrol 1.2 PureTech 82", and hyphen vs space in model names.
     *
     * So: strip diacritics, collapse everything non-alphanumeric to a single
     * space, lowercase. Two strings a human would call the same now compare equal.
     * This deliberately does NOT loosen WHICH fields must match — make, model and
     * engine must still all agree.
     */
    function normalizeForCompare(str) {
      return String(str ?? "")
        // Split accented characters into base + combining mark, then drop the
        // marks: "Ë" → "E". Handles CITROËN, SKODA/ŠKODA, PEUGEOT variants etc.
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase()
        // Any run of non-alphanumerics (comma, hyphen, slash, NBSP, tabs) → one space.
        .replace(/[^a-z0-9]+/g, " ")
        .trim();
    }

    function checkVehicleCompatibility(vehicle, skipYearCheck = false) {
      const vehicleYear = parseInt(vehicle.year, 10);

      const vMake = normalizeForCompare(vehicle.make);
      const vModel = normalizeForCompare(vehicle.model);
      const vEngine = normalizeForCompare(vehicle.engine);

      for (let i = 0; i < productFitments.length; i++) {
        const fitmentContainer = productFitments[i];
        const fitments = fitmentContainer.fitments || [];
        for (let j = 0; j < fitments.length; j++) {
          const fitment = fitments[j];

          const fMake = normalizeForCompare(fitment.make);
          const fModel = normalizeForCompare(fitment.model);
          const fEngine = normalizeForCompare(fitment.engine);

          // Engine is compared LENIENTLY in one direction: the metafield stores
          // "Petrol, 1.2 PureTech 82" while a saved vehicle may hold only
          // "1.2 PureTech 82" (the proxy splits fuelType off, and the YMM dropdowns
          // store the engine without it). Requiring exact equality here rejected
          // vehicles the server had already matched. Containment in EITHER direction
          // is still far stricter than a prefix match, and make+model must match
          // exactly, so this cannot pull in an unrelated vehicle.
          const engineMatches =
            fEngine === vEngine ||
            (vEngine.length > 0 && fEngine.includes(vEngine)) ||
            (fEngine.length > 0 && vEngine.includes(fEngine));

          if (fMake === vMake && fModel === vModel && engineMatches) {
            if (skipYearCheck) { return true; }
            const yearStr = String(fitment.year).trim();
            const matches = yearStr.match(/\[?(\d+),(\d+)\]?/);
            if (matches) {
              const startYear = parseInt(matches[1], 10);
              const endYear = parseInt(matches[2], 10);
              if (vehicleYear >= startYear && vehicleYear <= endYear) { return true; }
            } else {
              // A single year, or an unparseable range. Previously this fell through
              // and reported "not compatible" — treat a lone 4-digit year as a match
              // rather than silently rejecting on a formatting difference.
              const single = yearStr.match(/(\d{4})/);
              if (single && parseInt(single[1], 10) === vehicleYear) { return true; }
            }
          }
        }
      }
      return false;
    }

    function setupEventListeners() {
      if (elements.checkBtn) {
        elements.checkBtn.addEventListener("click", () => {
          const vehicle = getSelectedVehicle();
          if (!vehicle) { messaging.showErrorModel("Please select Make, Model, and Year"); return; }
          verifyByModel();
        });
      }
      if (elements.checkPlateBtn) { elements.checkPlateBtn.addEventListener("click", verifyByRegistration); }
      if (elements.clearPlateBtn) {
        elements.clearPlateBtn.addEventListener("click", () => {
          elements.plate.value = ""; elements.plate.focus();
        });
      }
      if (elements.changeVehicleBtn) {
        elements.changeVehicleBtn.addEventListener("click", () => { messaging.showSelectionView(); });
      }
      if (elements.plate) {
        elements.plate.addEventListener("keypress", (e) => {
          if (e.key === "Enter") { verifyByRegistration(); }
        });
      }
    }

    if (elements.browseBtn) {
      elements.browseBtn.addEventListener("click", async function () {
        const reg = elements.resultPlate?.value?.trim();
        if (reg) {
          try {
            const response = await fetch("/a/vehicles/getCartellResponse", {
              method: "POST", headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ registrationNumber: reg }),
            });
            const result = await response.json();
            if (!result.success || !result.vehicles?.length) {
              messaging.showBrowseError("Unable to find compatible products for this vehicle.");
              return;
            }
            const vehicle = result.vehicles[0];
            redirectToVehicleSearch(vehicle);
            return;
          } catch (error) {
            messaging.showBrowseError("Something went wrong. Please try again.");
            console.error("Cartell route error:", error);
            return;
          }
        }
        if (currentVehicle) {
          redirectToVehicleSearch({
            make: currentVehicle.make, model: currentVehicle.model,
            engine: currentVehicle.engine || "", year: currentVehicle.year, limit:250,
          });
          return;
        }
        const savedVehicle = loadSavedVehicle();
        if (savedVehicle?.make && savedVehicle?.model && savedVehicle?.year) {
          redirectToVehicleSearch({
            make: savedVehicle.make, model: savedVehicle.model,
            engine: savedVehicle.engine || "", year: savedVehicle.year, limit:250,
          });
          return;
        }
        messaging.showBrowseError("No vehicle selected.");
      });
    }

    function getCollectionHandleFromURL() {
      const path = window.location.pathname;
      const match = path.match(/\/collections\/([^\/]+)/);
      return match ? match[1] : null;
    }

    /**
     * Read the target collection out of the PDP breadcrumb.
     *
     * ── Why this beats the remembered collection (2026-08) ────────────
     * sessionStorage records where the shopper was BROWSING. That is wrong
     * whenever they did not browse there: arriving from search, a direct link,
     * an email or Google drops them on a PDP with a stale (or absent) memory,
     * so an engine oil could send them to the bulbs collection.
     *
     * The breadcrumb is rendered PER PRODUCT and states what the product
     * actually is, regardless of how the shopper arrived. For the Fuchs oil:
     *   Home > Oils, Fluids & Lubricants > Engine Oil > <product>
     *
     * Only /collections/ links count. The markup mixes three crumb types:
     *   <a href="https://www.fixra.com">         Home, absolute, not a collection
     *   <a href="/pages/oils-fluids-lubricants"> a PAGE, not a filterable collection
     *   <a href="/collections/engine-oil">       what we want
     *   <p>Fuchs Titan ...</p>                    the product, never a link
     * Taking the LAST /collections/ link yields the most specific category.
     *
     * Returns null when the theme renders no breadcrumb, so the caller falls
     * through to the remembered collection and then the hub.
     */
    function getCollectionHandleFromBreadcrumb() {
      try {
        const container = document.querySelector('.breadcrumb, .breadcrumb_inner_div');
        if (!container) return null;

        const links = container.querySelectorAll('a[href*="/collections/"]');
        if (!links.length) return null;

        // Last match = deepest crumb = most specific collection.
        for (let i = links.length - 1; i >= 0; i--) {
          const href = links[i].getAttribute('href') || '';
          // Match on the path only, so a query string or an absolute URL is fine
          // and "/pages/..." can never be mistaken for a collection.
          const m = href.match(/\/collections\/([^\/?#]+)/);
          if (!m) continue;
          const handle = m[1];
          // "all" is the catch-all collection - filtering it is the same as the
          // hub but slower, so treat it as no signal.
          if (!handle || handle === 'all') continue;
          return handle;
        }
        return null;
      } catch (e) {
        return null;
      }
    }

    /**
     * Which collection should "Browse Compatible Products" send the shopper to?
     *
     * Resolved in falling order of trust:
     *   1. the URL      - already on a collection, so that IS the context
     *   2. the breadcrumb - what the PRODUCT is; correct however they arrived
     *   3. sessionStorage - the last fitment collection they browsed
     *   4. null         - caller falls back to the /pages/car-parts hub
     *
     * ── History ─────────────────────────────────────────
     * Originally step 1 alone. On a PDP the path is /products/<handle>, so it
     * never matched and EVERY shopper landed on the hub.
     *
     * Step 3 was added next, but it only knows where they were BROWSING - so a
     * shopper who reached an engine-oil PDP from search still got sent to
     * whatever collection they last looked at (the reported bulbs redirect).
     *
     * Step 2 fixes that: the breadcrumb is per-product and states the real
     * category. It is checked BEFORE sessionStorage because the product itself
     * is a stronger signal than browsing history. sessionStorage remains as the
     * fallback for themes/templates that render no breadcrumb.
     */
    function getTargetCollectionHandle() {
      const fromUrl = getCollectionHandleFromURL();
      if (fromUrl) return fromUrl;

      // The product's own category, from the breadcrumb. Preferred over the
      // remembered collection because it is correct even when the shopper
      // arrived from search or a direct link rather than by browsing.
      const fromBreadcrumb = getCollectionHandleFromBreadcrumb();
      if (fromBreadcrumb) return fromBreadcrumb;

      try {
        const raw = sessionStorage.getItem('partra_last_fitment_collection');
        if (!raw) return null;
        const saved = JSON.parse(raw);
        // 2h expiry: long enough for a real browsing session, short enough that a
        // tab left open overnight does not redirect somewhere unexpected.
        const TWO_HOURS = 2 * 60 * 60 * 1000;
        if (!saved?.handle || Date.now() - (saved.savedAt || 0) > TWO_HOURS) return null;
        return saved.handle;
      } catch (e) {
        return null;
      }
    }

    function redirectToVehicleSearch(vehicle) {
      const { make, model, engine, year } = vehicle;
      const rawCarName = `${make} ${model} ${engine}`;
      const slug = rawCarName.replace(/[^a-zA-Z0-9]+/g, '-').replace(/^-+|-+$/g, '');

      // ── PRESERVE HOW THE VEHICLE WAS FOUND (2026-08) ────────────────────
      // This used to hardcode `type: 'registration'` and never carry a
      // registrationNumber. The effect: after "Browse Compatible Products", the
      // saved vehicle claimed to be a registration lookup but had no plate — so
      // autoCheckSavedVehicle's `saved.type === 'registration' && saved.registrationNumber`
      // check failed and the yellow number-plate box vanished on every subsequent
      // PDP. A shopper who searched by REG suddenly looked like they had used the
      // make/model dropdowns.
      //
      // The plate is recovered in priority order:
      //   1. the plate shown in the result box (this session's lookup),
      //   2. the plate on the previously saved vehicle (set by verifyByRegistration),
      //   3. anything the caller passed in.
      // If none exist the vehicle was genuinely found by MODEL, and we say so —
      // claiming 'registration' without a plate is what caused the bug.
      let priorSaved = null;
      try {
        priorSaved = JSON.parse(localStorage.getItem('vehicle_fitment_active') || 'null');
      } catch (e) { /* ignore malformed */ }

      const plate =
        (elements.resultPlate?.value || '').trim() ||
        (priorSaved?.registrationNumber || '').trim() ||
        (vehicle.registrationNumber || '').trim();

      const vehicleData = {
        type: plate ? 'registration' : 'model',
        make: make || '', model: model || '',
        engine: engine || '', year: year || '', rawCarName: rawCarName, slug: slug,
        makeIndex: null, modelIndex: null, engineIndex: null,
        savedAt: Date.now(),
        ...(plate ? { registrationNumber: plate.toUpperCase() } : {}),
      };
      localStorage.setItem('vehicle_fitment_active', JSON.stringify(vehicleData));
      localStorage.setItem('vehiclesDon', JSON.stringify([{
        make: encodeURIComponent(make || ''), model: encodeURIComponent(model || ''),
        engine: encodeURIComponent(engine || ''), year: encodeURIComponent(year || '')
      }]));
      const params = new URLSearchParams({
        make: make || '', model: model || '', engine: engine || '', year: year || '',
      });
      // Current collection if we are on one, else the one the shopper came from,
      // else the hub. See getTargetCollectionHandle.
      const targetHandle = getTargetCollectionHandle();
      let url;
      if (targetHandle) {
        // limit=250 matches what the fitment widget uses, so the filtered collection
        // shows the whole matching set rather than one paginated page of it.
        params.set('limit', '250');
        url = `/collections/${targetHandle}?${params.toString()}`;
      } else {
        url = '/pages/car-parts';
      }
      console.log('Redirecting to:', url, targetHandle ? '(collection)' : '(hub fallback)');
      window.location.href = url;
    }

    function showWidget() {
      const skeleton = document.getElementById("vf-skeleton-container");
      if (skeleton) skeleton.style.display = "none";
      const wrapper = document.getElementById("verify-fitment-wrapper");
      if (wrapper) wrapper.style.display = "block";
      const widgetContainer = document.querySelector(".verify-fitment-vertical-wrapper");
      if (widgetContainer) widgetContainer.style.display = "block";
    }

    function loadSavedVehicleIntoDropdowns() {
      const savedVehicle = loadSavedVehicle();
      if (!savedVehicle) return;
      console.log("Loading saved vehicle into dropdowns:", savedVehicle);

      if (savedVehicle.makeIndex !== undefined && customSelects.make) {
        const makeLabel = lookups.makes[savedVehicle.makeIndex] || '';
        customSelects.make.setValue(savedVehicle.makeIndex.toString(), makeLabel);
        setTimeout(() => {
          handleMakeChange(savedVehicle.makeIndex.toString());
          if (savedVehicle.modelIndex !== undefined && customSelects.model) {
            setTimeout(() => {
              const modelLabel = lookups.models[savedVehicle.modelIndex] || '';
              customSelects.model.setValue(savedVehicle.modelIndex.toString(), modelLabel);
              handleModelChange(savedVehicle.modelIndex.toString());
              if (savedVehicle.engineIndex !== undefined && customSelects.engine) {
                setTimeout(() => {
                  const engineLabel = lookups.engines[savedVehicle.engineIndex] || '';
                  customSelects.engine.setValue(savedVehicle.engineIndex.toString(), engineLabel);
                  handleEngineChange(savedVehicle.engineIndex.toString());
                  if (savedVehicle.year !== undefined && customSelects.year) {
                    setTimeout(() => {
                      customSelects.year.setValue(savedVehicle.year.toString(), savedVehicle.year.toString());
                      setTimeout(() => { verifyByModel(); }, 200);
                    }, 100);
                  }
                }, 100);
              }
            }, 100);
          }
        }, 100);
      }
    }

    function init() {
      initializeCustomSelects();
      modeManager.init();
      setupEventListeners();
      modeManager.switchMode(currentMode);
      setTimeout(() => { showWidget(); }, 500);
      setTimeout(() => { loadSavedVehicleIntoDropdowns(); }, 700);
      setTimeout(() => { autoCheckSavedVehicle(); }, 1000);

      if (sessionStorage.getItem('partra_show_vf_error') === '1') {
        sessionStorage.removeItem('partra_show_vf_error');
        setTimeout(function() {
          var target = document.getElementById('verify-fitment-wrapper') || document.getElementById('verify-fitment');
          if (target) { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
          setTimeout(function() {
            if (currentMode === 'model') {
              messaging.showErrorModel('Please select your vehicle details to check compatibility');
            } else {
              messaging.showError('Please enter your registration to check compatibility');
            }
          }, 400);
        }, 500);
      }
    }

    init();
  }

  if (typeof window !== "undefined") {
    window.initVerifyFitment = initVerifyFitment;
  }
})();